var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightingInstant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71363 4.43521C7.65482 4.31318 7.53168 4.2353 7.39618 4.2353H5.14852L7.00682 0.510797C7.06149 0.401525 7.05565 0.271591 6.99136 0.167524C6.92707 0.0634574 6.81386 0 6.69175 0H2.46543C2.31857 0 2.1872 0.0913515 2.13559 0.228875L0.0224248 5.87593C-0.018145 5.98449 -0.00304555 6.10584 0.0626766 6.20097C0.128717 6.29609 0.236717 6.35295 0.352267 6.35295H2.71858L1.41952 11.5616C1.37927 11.7226 1.45631 11.8897 1.60492 11.9635C1.75564 12.0374 1.93349 11.9958 2.03621 11.8677L7.67135 4.80884C7.75591 4.70267 7.77208 4.55756 7.71363 4.43521Z",
    fill: "#FFB834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingInstant);
export default __webpack_public_path__ + "static/media/lightingInstant.8c24191b6399cd9afe70cec495dbbfa9.svg";
export { ForwardRef as ReactComponent };